
























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { getDataOptional } from '@/utils/dashboardUtils';
import { BusinessWalletDashboard } from '@/api/interfaces/business-wallet-dashboard.interface';
import { BusinessPayoutMethod } from '@/api/interfaces/business-payout-withdraw.interface';
import { insideProviderIframe } from '@/utils/providerIframe';
import {
  openCentralizedPopupWindow,
  closeOnWindowPopupUrlMatches
} from '@/utils/windowPopup';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import ModalOptions from '@/components/Modal/ModalOptions';
import DateUtils from '@/utils/DateUtils';
import eventBus from '@/utils/eventBus';

import AnalyticsCard from '@/componentsV2/molecules/AnalyticsCard/AnalyticsCard.vue';
import Link from '@/componentsV2/atoms/Link/Link.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import PlaidButton from '@/componentsV2/organisms/PlaidButton/PlaidButton.vue';
import ExternalLinkIcon from '@/components/icons/ExternalLink.vue';
import flagKeys from '@/constants/flagKeys';
import CampaignService from '@/api/CampaignService';
import BusinessPayoutService from '@/api/BusinessPayoutService';
import segmentIo from '@/utils/segment.io';
import { isRemoteLoading } from '@/utils/remote-loading';

import { AnalyticsCardListItem } from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

@Component({
  components: {
    AnalyticsCard,
    CoinsIcon,
    FilledButton,
    Link,
    Typography,
    PlaidButton,
    ExternalLinkIcon
  }
})
export default class CoinsOverviewGrid extends Vue {
  @Prop({ required: true }) dashboardData!: BusinessWalletDashboard | null;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: () => [] }) additionalCards!: AnalyticsCardListItem[];
  @Prop({ default: false }) hideTransferHistory?: boolean;
  @Prop({ default: false }) hidePayoutHistory?: boolean;
  @Prop({ default: true }) hideStripeLink?: boolean;
  @Prop() onUpdate!: any;

  withdrawLoading: boolean = false;
  stripeDashboardLink: string | null = null;
  campaignService = new CampaignService();
  businessPayoutService = new BusinessPayoutService();

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isCampaignManagementActive() {
    return this.flags.includes(flagKeys.sellCoinsCampaignManagement);
  }

  get isPlaidConnectActive() {
    return this.flags.includes(flagKeys.plaidConnect);
  }

  get isPlaidTestConnectActive() {
    return this.flags.includes(flagKeys.plaidTestConnect);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'sellCoins.overview';
  }

  get isWithdrawDisabled() {
    return (
      this.dashboardData &&
      (this.dashboardData.balance.available <= 0 ||
        !this.dashboardData.balance.passedWithdrawCommonValidations)
    );
  }

  get isPurchaseHistoryDisabled() {
    return !(this.dashboardData && this.dashboardData.coins.sold.amount > 0);
  }

  get isPayoutHistoryDisabled() {
    return !(
      this.dashboardData &&
      this.dashboardData.payouts.netPaidTotal +
        this.dashboardData.payouts.netInTransitTotal >
        0
    );
  }

  get cardsToDisplay() {
    const baseCards = this.getBaseCards();
    return [...baseCards, ...this.additionalCards];
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get payoutInsighStatusMessage(): string {
    if (this.dashboardData) {
      if (this.dashboardData.payouts.netInTransitTotal > 0) {
        return `${
          this.dashboardData.formatted.payouts.netInTransitTotal
        } ${this.$t(`${this.tPrefix}.cards.payout.insightProcessing`)}`;
      }

      if (this.dashboardData.payouts.last) {
        const formattedDate = DateUtils.formattedDate({
          date: new Date(this.dashboardData.payouts.last.date),
          applyTimezone: true
        });

        return `Your last payout of ${
          this.dashboardData.formatted.payouts.last.amount
        } was sent on ${formattedDate}`;
      }
    }

    return `${this.$t(`${this.tPrefix}.cards.payout.insightEmpty`)}`;
  }

  clickGoToStripe() {
    segmentIo.track('Clicked Go To Stripe Dashboard');
  }

  checkStripeConnect() {
    const { stripe_connection = null } = this.$route.query;

    if (stripe_connection === 'success') {
      this.$router.replace({ query: undefined });

      this.$analytics({
        eventCategory: 'Sell Coins | Stripe Connection',
        eventAction: 'route'
      });

      this.onWithdrawClick();
    }
  }

  gotoStripeLink(url = this.$store.state.stripe.connectURL) {
    this.$analytics({
      eventCategory: 'Gift Coins Page | Sell Gift Coins button',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Sell Gift Coins" button'
    });

    segmentIo.track('Stripe Dashboard Redirected');

    if (insideProviderIframe()) {
      const newWindow = (openCentralizedPopupWindow(
        url,
        'ConnectOauth'
      ) as unknown) as Window;

      closeOnWindowPopupUrlMatches(
        newWindow,
        process.env.VUE_APP_DASHBOARD_URL || 'twism'
      );
    } else {
      if (isRemoteLoading()) {
        window.parent.open(`${url}`, '_self');
        return;
      }
      window.open(`${url}`, '_self');
    }
  }

  async openStripeConnectModal(autoRedirect = false) {
    const { data } = await this.campaignService.checkBusiness();
    const { payment } = data;

    if (autoRedirect) {
      if (window.parent) return window.parent.open(payment.url, '_blank');
      return window.open(payment.url, '_blank');
    }

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'stripeRedirect'
      }),
      {
        onConfirm: async () => {
          this.gotoStripeLink(payment.url);
        }
      }
    );
  }

  async openWithdrawModal() {
    this.withdrawLoading = true;

    const { data } = await this.businessPayoutService.getWithdrawDetails({
      method: BusinessPayoutMethod.STANDARD
    });

    this.withdrawLoading = false;

    if (!data) {
      return;
    }

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'withdrawSellCoins'
      }),
      {
        data,
        onConfirm: async () => {
          if (this.onUpdate) {
            this.onUpdate();
          }
        }
      }
    );
  }

  get stripeLinked() {
    if (this.isPlaidConnectActive) {
      return false;
    }

    const { stripeLinked } = this.businessInfo;
    return stripeLinked;
  }

  openStripeDetailsPendingModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'stripeDetailsPendingModal'
      }),
      {
        onConfirm: () => this.openStripeConnectModal(true),
        onGoToWithdraw: () => this.openWithdrawModal()
      }
    );
  }

  openStripeUnlockWithdrawModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'stripeUnlockWithdrawModal'
      }),
      {
        onConfirm: () => this.openStripeConnectModal(true)
      }
    );
  }

  async onWithdrawClick() {
    segmentIo.track('Clicked Withdraw Button', {
      'Stripe Linked': this.stripeLinked
    });

    if (this.isPlaidConnectActive || this.stripeLinked) {
      try {
        this.withdrawLoading = true;
        const { data } = await this.campaignService.checkStripeStatus();
        const { canWithdraw, hasNonBlockingPending } = data;
        if (canWithdraw) {
          if (hasNonBlockingPending) {
            return this.openStripeDetailsPendingModal();
          }
          return this.openWithdrawModal();
        }
        return this.openStripeUnlockWithdrawModal();
      } catch (error) {
        console.error(error);
        return this.$notification(
          'Stripe verification failed. Please try again in a few minutes',
          'error'
        );
      } finally {
        this.withdrawLoading = false;
      }
    }

    return this.openStripeConnectModal();
  }

  gotoPurchaseHistory() {
    this.$router.push('/sell-coins/purchase-history');
  }

  onPayoutsHistoryClick() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        `payoutsHistory`,
        false,
        true,
        true,
        true,
        true
      ),
      {
        onConfirm: async () => {}
      }
    );
  }

  async getStripeLink() {
    const { data } = await this.campaignService.checkBusiness();
    const { payment } = data;

    this.stripeDashboardLink = payment.url;
  }

  mounted() {
    this.checkStripeConnect();
    this.getStripeLink();
  }

  getBaseCards() {
    const cards: Record<string, AnalyticsCardListItem> = {
      withdraw: {
        variant: 'white',
        insightVariant: 'regular',
        infos: {
          title: '',
          largeTitle: String(this.$t(`${this.tPrefix}.cards.withdraw.label`)),
          disableAbbreviateAmount: true,
          tooltipIconPlacement: 'after-title',
          amount: getDataOptional(
            this.dashboardData,
            'formatted.balance.available',
            '--'
          ),
          tooltipText: String(
            this.$t(`${this.tPrefix}.cards.withdraw.tooltip`)
          ),
          insightText: getDataOptional(this.dashboardData, 'balance.pending')
            ? String(
                `+${getDataOptional(
                  this.dashboardData,
                  'formatted.balance.pending'
                )} ${this.$t(`${this.tPrefix}.cards.withdraw.insight`)}`
              )
            : '<span />',
          counterFractionDigits: 2
        },
        components: {
          rightTop: {
            as: this.isPlaidConnectActive ? 'PlaidButton' : 'FilledButton',
            text: this.$t(`${this.tPrefix}.cards.withdraw.btn`),
            type: 'submit',
            disabled: this.isWithdrawDisabled,
            colorSchema: 'new-gradient',
            action: this.onWithdrawClick,
            loading: this.withdrawLoading
          }
        }
      },
      lifetimeEarnings: {
        variant: 'white',
        insightVariant: 'regular',
        infos: {
          title: '',
          largeTitle: String(
            this.$t(`${this.tPrefix}.cards.lifetimeEarnings.label`)
          ),
          disableAbbreviateAmount: true,
          tooltipIconPlacement: 'after-title',
          amount: getDataOptional(
            this.dashboardData,
            'formatted.balance.totalRevenueFromCoinSales',
            '--'
          ),
          tooltipText: String(
            this.$t(`${this.tPrefix}.cards.lifetimeEarnings.tooltip`)
          ),
          insightText: String(
            this.$t(`${this.tPrefix}.cards.lifetimeEarnings.insight`)
          ),
          counterFractionDigits: 2
        }
      }
    };

    return Object.values(cards);
  }
}
